var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center ma-2"},[_c('v-snackbar',{attrs:{"value":_vm.content.snackbar},scopedSlots:_vm._u([{key:"action",fn:function({ attrs }){return [_c('v-btn',_vm._b({attrs:{"color":"pink","text":""},on:{"click":_vm.close}},'v-btn',attrs,false),[_vm._v(" 关闭 ")])]}}])},[_vm._v(" "+_vm._s(_vm.content.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }